import { render, staticRenderFns } from "./Imoveis.vue?vue&type=template&id=064fb441&scoped=true&"
import script from "./imoveis.js?vue&type=script&lang=js&"
export * from "./imoveis.js?vue&type=script&lang=js&"
import style0 from "./Imoveis.vue?vue&type=style&index=0&id=064fb441&scoped=true&lang=css&"
import style1 from "./Imoveis.vue?vue&type=style&index=1&id=064fb441&lang=scss&rel=stylesheet%2Fscss&scoped=true&"
import style2 from "./Imoveis.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fb441",
  null
  
)

export default component.exports